import React from "react";
import ProgressBar from "sushiweb/ProgressBar";

const FullPageLoader = () => {
  return <ProgressBar id="sushi-progressBar" active={true} />;
};

export default FullPageLoader;
